const checkForPropsValue = (
  componentField,
  pageLevelField,
  dictionaryField
) => {
  if (componentField && componentField.value && componentField.value.length) {
    return componentField;
  } else if (pageLevelField && pageLevelField.value && pageLevelField.value.length) {
    return pageLevelField;
  }
  return dictionaryField;
};

export default checkForPropsValue;